import { IDictionary } from "../../../typings";
import { ISize } from "../size-controller";

interface IRatio extends ISize {
  amount: number;
  maxWidth?: number;
  maxHeight?: number;
}

export type Ratios = IDictionary<IRatio>;

export const ratios: IDictionary<Ratios> = {
  default: {
    20: { width: 260, height: 13, amount: 20, maxWidth: 400 },
    10: { width: 160, height: 16, amount: 10, maxWidth: 400 },
    6.67: { width: 126.7, height: 19, amount: 6.67, maxWidth: 200 },
    5: { width: 110, height: 22, amount: 5, maxWidth: 200 },
    4: { width: 100, height: 25, amount: 4, maxWidth: 200 },
    3.33: { width: 93.3, height: 28, amount: 3.33, maxWidth: 200 },
    2.86: { width: 88.6, height: 31, amount: 2.86, maxWidth: 200 },
    2.5: { width: 85, height: 34, amount: 2.5, maxWidth: 200 },
    2.22: { width: 82.2, height: 37, amount: 2.22, maxWidth: 200 },
    2: { width: 80, height: 40, amount: 2, maxWidth: 200 },
    1.82: { width: 72.8, height: 43, amount: 1.82, maxWidth: 200 },
    1.67: { width: 76.7, height: 46, amount: 1.67, maxWidth: 200 },
    1.54: { width: 75.4, height: 49, amount: 1.54, maxWidth: 200 },
    1.43: { width: 74.3, height: 52, amount: 1.43, maxWidth: 200 },
    1.33: { width: 73.3, height: 55, amount: 1.33, maxWidth: 200 },
    1.25: { width: 72.5, height: 58, amount: 1.25, maxWidth: 200 },
    1.18: { width: 71.8, height: 61, amount: 1.18, maxWidth: 200 },
    1.11: { width: 71.1, height: 64, amount: 1.11, maxWidth: 200 },
    1.05: { width: 70.5, height: 67, amount: 1.05, maxWidth: 200 },
    1: { width: 70, height: 70, amount: 1, maxWidth: 200 },
    0.95: { width: 67, height: 70.5, amount: 0.95, maxHeight: 200 },
    0.9: { width: 64, height: 71.11, amount: 0.9, maxHeight: 200 },
    0.85: { width: 61, height: 71.8, amount: 0.85, maxHeight: 200 },
    0.8: { width: 58, height: 72.5, amount: 0.8, maxHeight: 200 },
    0.75: { width: 55, height: 73.3, amount: 0.75, maxHeight: 200 },
    0.7: { width: 52, height: 74.3, amount: 0.7, maxHeight: 200 },
    0.65: { width: 49, height: 75.4, amount: 0.65, maxHeight: 200 },
    0.6: { width: 46, height: 76.7, amount: 0.6, maxHeight: 200 },
    0.55: { width: 43, height: 78.2, amount: 0.55, maxHeight: 200 },
    0.5: { width: 40, height: 80, amount: 0.5, maxHeight: 200 },
    0.45: { width: 37, height: 82.2, amount: 0.45, maxHeight: 200 },
    0.4: { width: 34, height: 85, amount: 0.4, maxHeight: 200 },
    0.35: { width: 31, height: 88.6, amount: 0.35, maxHeight: 200 },
    0.3: { width: 28, height: 93.3, amount: 0.3, maxHeight: 200 },
    0.25: { width: 25, height: 100, amount: 0.25, maxHeight: 200 },
    0.2: { width: 22, height: 110, amount: 0.2, maxHeight: 200 },
    0.15: { width: 19, height: 126.7, amount: 0.15, maxHeight: 200 },
    0.1: { width: 16, height: 160, amount: 0.1, maxWidth: 200 },
    0.05: { width: 13, height: 260, amount: 0.05, maxWidth: 200 },
  },
  heatTransfer: {
    20: { width: 260, height: 13, amount: 20, maxHeight: 750 },
    10: { width: 160, height: 16, amount: 10, maxHeight: 750 },
    6.67: { width: 126.7, height: 19, amount: 6.67, maxHeight: 750 },
    5: { width: 110, height: 22, amount: 5, maxHeight: 750 },
    4: { width: 100, height: 25, amount: 4, maxHeight: 750 },
    3.33: { width: 93.3, height: 28, amount: 3.33, maxHeight: 750 },
    2.86: { width: 88.6, height: 31, amount: 2.86, maxHeight: 750 },
    2.5: { width: 85, height: 34, amount: 2.5, maxHeight: 750 },
    2.22: { width: 82.2, height: 37, amount: 2.22, maxHeight: 750 },
    2: { width: 80, height: 40, amount: 2, maxHeight: 750 },
    1.82: { width: 72.8, height: 43, amount: 1.82, maxHeight: 750 },
    1.67: { width: 76.7, height: 46, amount: 1.67, maxHeight: 750 },
    1.54: { width: 75.4, height: 49, amount: 1.54, maxHeight: 750 },
    1.43: { width: 74.3, height: 52, amount: 1.43, maxHeight: 750 },
    1.33: { width: 73.3, height: 55, amount: 1.33, maxHeight: 750 },
    1.25: { width: 72.5, height: 58, amount: 1.25, maxHeight: 750 },
    1.18: { width: 71.8, height: 61, amount: 1.18, maxHeight: 750 },
    1.11: { width: 71.1, height: 64, amount: 1.11, maxHeight: 750 },
    1.05: { width: 70.5, height: 67, amount: 1.05, maxHeight: 750 },
    1: { width: 70, height: 70, amount: 1, maxHeight: 750 },
    0.95: { width: 67, height: 70.5, amount: 0.95, maxWidth: 750 },
    0.9: { width: 64, height: 71.11, amount: 0.9, maxWidth: 750 },
    0.85: { width: 61, height: 71.8, amount: 0.85, maxWidth: 750 },
    0.8: { width: 58, height: 72.5, amount: 0.8, maxWidth: 750 },
    0.75: { width: 55, height: 73.3, amount: 0.75, maxWidth: 750 },
    0.7: { width: 52, height: 74.3, amount: 0.7, maxWidth: 750 },
    0.65: { width: 49, height: 75.4, amount: 0.65, maxWidth: 750 },
    0.6: { width: 46, height: 76.7, amount: 0.6, maxWidth: 750 },
    0.55: { width: 43, height: 78.2, amount: 0.55, maxWidth: 750 },
    0.5: { width: 40, height: 80, amount: 0.5, maxWidth: 750 },
    0.45: { width: 37, height: 82.2, amount: 0.45, maxWidth: 750 },
    0.4: { width: 34, height: 85, amount: 0.4, maxWidth: 750 },
    0.35: { width: 31, height: 88.6, amount: 0.35, maxWidth: 750 },
    0.3: { width: 28, height: 93.3, amount: 0.3, maxWidth: 750 },
    0.25: { width: 25, height: 100, amount: 0.25, maxWidth: 750 },
    0.2: { width: 22, height: 110, amount: 0.2, maxWidth: 750 },
    0.15: { width: 19, height: 126.7, amount: 0.15, maxWidth: 750 },
    0.1: { width: 16, height: 160, amount: 0.1, maxHeight: 750 },
    0.05: { width: 13, height: 260, amount: 0.05, maxHeight: 750 },
  },
};
